import { getFontSizeInPx } from "src/utils"

// variables defined in src/styles/home.scss
export function getExpectedGraphWidth(yAxisWidth: number): number {
  const computedStyles = getComputedStyle(document.documentElement)
  const widthInRem = parseFloat(computedStyles.getPropertyValue("--feed-width"))
  const gapInRem = parseFloat(computedStyles.getPropertyValue("--home-column-gap"))
  const fontSize = getFontSizeInPx()

  if (isNaN(widthInRem) || isNaN(gapInRem) || isNaN(fontSize)) {
    return window.innerWidth - yAxisWidth
  }

  return window.innerWidth - ((widthInRem + gapInRem) * fontSize) - yAxisWidth
}
